import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import getTranslation from '../../../strings/i18n';
import { Inset, Stack } from 'syf-component-library/ui/spacing';
import { ErrorBoundary } from 'syf-component-library/ui/templates';
import Viewport from 'syf-component-library/ui/templates/Viewport';
import useDeviceWidth from '../../../hooks/use-device-width';
import { StyledText } from '../../../styles/text';
import MobileActivityRow from '../../common/mobile-activity-row';
import { StyledMobileRowShadow } from '../../common/mobile-activity-row/subcomponents';
import TableList from '../../common/table-list';
import TransactionRow from '../../common/transaction-row';
import SelectPayGenericError from '../states/generic-error';
var InstallmentsHeader = function (_a) {
    var selectedTransaction = _a.selectedTransaction;
    var t = getTranslation().t;
    var isMobile = useDeviceWidth();
    if (!selectedTransaction) {
        return null;
    }
    return (_jsxs(Inset, { vertical: isMobile ? 'medium' : 'xlarge', top: "base", bottom: isMobile ? 'large' : 'xlarge', children: [_jsx(StyledText, { size: "large", weight: "light", align: isMobile ? 'center' : undefined, children: t('selectPay.installmentsSelectedRowHeading') }), _jsx(Stack, {}), _jsxs(ErrorBoundary, { fallback: _jsx(SelectPayGenericError, {}), children: [_jsx(Viewport.Mobile, { children: _jsx(StyledMobileRowShadow, { children: _jsx(MobileActivityRow, { item: selectedTransaction, isolated: true }) }) }), _jsx(Viewport.Desktop, { children: _jsx(TableList, { children: _jsx(TransactionRow, { item: selectedTransaction, isolated: true }) }) })] })] }));
};
export default InstallmentsHeader;
//# sourceMappingURL=index.js.map